module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crew_right"
  }, [_c('div', {
    staticClass: "conInner"
  }, [_c('div', {
    staticClass: "orderInfo"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "order_detail_wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v("订单号："), _c('span', [_vm._v(_vm._s(_vm.info.sn))])]), _vm._v(" "), _c('h2', [_vm._v("订单状态:"), _c('span', [_vm._v(_vm._s(_vm.info.statusText))])]), _vm._v(" "), _c('div', {
    staticClass: "order_invoice"
  }), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [(_vm.info.status === 0) ? _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.playOrder
    }
  }, [_vm._v("按此为订单付款")]) : _vm._e(), _vm._v(" "), ((_vm.info.status === 0 || _vm.info.status === 2) && _vm.aux !== 5) ? _c('Button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.showCancel
    }
  }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), (_vm.info.status === 5 && _vm.aux !== 3 && _vm.aux !== 4) ? _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.rogConfirm
    }
  }, [_vm._v("确认收货")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "receiver"
  }, [_c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("收货人信息")]), _vm._v(" "), _c('td', [_c('div', [_c('label', [_vm._v("收货人:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.shipName))])]), _vm._v(" "), (_vm.info.shipMobile !== '') ? _c('div', [_c('label', [_vm._v("手机:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.shipMobile))])]) : _vm._e(), _vm._v(" "), (_vm.info.shipTel !== '') ? _c('div', [_c('label', [_vm._v("联系电话:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.shipTel))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', [_vm._v("收货地址:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.shippingArea))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("邮编:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.info.shipZip))])])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("下单时间:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.payTime))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("支付方式:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.paymentName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("订单附言:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.remark))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("配送方式:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.shippingType))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("发货时间:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.saleCmplTime))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("成交时间:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.completeTime))])]), _vm._v(" "), (_vm.orderSn) ? _c('tr', [_c('th', [_vm._v("退换物流公司名称:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.logisticsCompanyName))])]) : _vm._e(), _vm._v(" "), (_vm.orderSn) ? _c('tr', [_c('th', [_vm._v("退回物流单号:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.logisticsSn))])]) : _vm._e(), _vm._v(" "), (_vm.orderSn) ? _c('tr', [_c('th', [_vm._v("退回地址:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.returnAddress))])]) : _vm._e(), _vm._v(" "), (_vm.orderSn && _vm.info.status == 3) ? _c('tr', [_c('th', [_vm._v("拒绝原因:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.refuseReason))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v("发票抬头:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.receiptPO.title))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("发票内容:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.receiptPO.content))])]), _vm._v(" "), (_vm.info.status == 8) ? _c('tr', [_c('th', [_vm._v("取消原因:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.cancelReason))])]) : _vm._e()])])]), _vm._v(" "), (_vm.info.dlvs) ? _c('div', {
    staticClass: "receiver",
    staticStyle: {
      "padding": "0 10px"
    }
  }, [_c('h1', {
    staticStyle: {
      "background-color": "#eee",
      "padding-left": "10px",
      "font-size": "16px"
    }
  }, [_vm._v("物流状态")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("物流公司:" + _vm._s(_vm.info.dlvs.logiName))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("货物单号:" + _vm._s(_vm.info.dlvs.logiNo))])]), _vm._v(" "), _c('div', {
    staticClass: "order-track"
  }, [_c('h1', {
    staticStyle: {
      "background-color": "#eee",
      "padding-left": "10px",
      "font-size": "16px"
    }
  }, [_vm._v("运货状态")]), _vm._v(" "), _c('div', {
    staticClass: "track-list"
  }, [_c('ul', _vm._l((_vm.queryLogistics), function(item, index) {
    return _c('li', {
      key: index
    }, [_vm._m(0, true), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('span', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(item.status))])])
  }), 0)]), _vm._v(" "), (!_vm.queryLogistics.length) ? _c('div', {
    staticStyle: {
      "padding": "10px",
      "text-align": "center"
    }
  }, [_vm._v("\n              暂无信息\n            ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "goodslist"
  }, [_c('h1', [_vm._v("商品清单")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.info.items), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        }
      }
    }, [_c('span', {
      staticClass: "cart-product-img",
      staticStyle: {
        "display": "block",
        "height": "50px"
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": item.image,
        "height": "50"
      }
    })])])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "link blue",
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n                    " + _vm._s(item.name) + "(" + _vm._s(item.sn) + ")\n                  ")])], 1), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(item.price.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.num))]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s((item.num * item.price).toFixed(2)))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_c('table', {
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("商品总金额:")]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(_vm.info.goodsAmount.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("配送费用:")]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(_vm.info.shippingAmount.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("现金券:")]), _vm._v(" "), _c('td', {
    staticClass: "discount_green"
  }, [_vm._v("￥" + _vm._s(_vm.info.userCoupon.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("优惠金额:")]), _vm._v(" "), _c('td', {
    staticClass: "discount_green"
  }, [_vm._v("￥" + _vm._s(_vm.info.discount ? _vm.info.discount.toFixed(2) : 0))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("自营购物积分:")]), _vm._v(" "), _c('td', {
    staticClass: "discount_green"
  }, [_vm._v("￥" + _vm._s(Number(_vm.info.selfShoppingPv).toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("订单总金额:")]), _vm._v(" "), _c('td', [_vm._v("￥" + _vm._s(_vm.info.orderAmount.toFixed(2)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("已付金额:")]), _vm._v(" "), _c('td', {
    staticClass: "already_money"
  }, [_vm._v("￥" + _vm._s((_vm.info.paymoney ? _vm.info.paymoney : 0).toFixed(2)))])])])])])])])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "530",
      "title": "请输入取消原因"
    },
    model: {
      value: (_vm.cancelModal),
      callback: function($$v) {
        _vm.cancelModal = $$v
      },
      expression: "cancelModal"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "480px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelOrder.apply(null, arguments)
      }
    }
  }, [_vm._v("确认取消订单")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "530"
    },
    model: {
      value: (_vm.frankingModal),
      callback: function($$v) {
        _vm.frankingModal = $$v
      },
      expression: "frankingModal"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "24px",
      "line-height": "1.5",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.frankingText))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.frankingHandle.apply(null, arguments)
      }
    }
  }, [_vm._v("确认")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "node-icon"
  }, [_c('i', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("图片")]), _vm._v(" "), _c('th', [_vm._v("商品名称")]), _vm._v(" "), _c('th', [_vm._v("价格")]), _vm._v(" "), _c('th', [_vm._v("数量")]), _vm._v(" "), _c('th', [_vm._v("小计")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17ef25fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/member-center/right/orderInfo.vue
// module id = 1539
// module chunks = 1